import React, {Component} from 'react';
import './PendingAccreditationRequestsList.css';
import PropTypes from 'prop-types';
import {Table} from 'reactstrap';
import {
    Redirect
} from "react-router-dom";
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import PaginationAccreditations from "../../commonComponents/paginationComponent/PaginationAccreditations.container";
import moment from "moment";
import Select from "../../commonComponents/customSelect/CustomSelect.container";

class PendingAccreditationRequestsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            continentFilter: null
        }
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to='/process-accreditation-requests' push/>;
        }

        return (
            <div className='pending-accreditation-requests-list-container'>
                <h4 className="page-label">{_.get(this.props.translation, 'accreditation_requests.pending_accreditation_requests_label')}</h4>
                <PaginationAccreditations
                    getDataForPage={this.getAccreditationRequestsByPage}
                />
                <div className='pending-accreditation-requests-filters-container'>
                    {this.renderFilters()}
                </div>
                {this.renderContent()}
            </div>
        );
    }

    getAccreditationRequestsByPage = (page) => {
        this.props.onLoadAccreditationRequests(this.props.group, page);
    };

    renderFilters() {
        if (this.props.isOrgBava) {
            let requestsPerContinentOptions = _.map(this.props.requestsPerContinent, (elem) => {
                return {
                    value: elem.value,
                    label: `${_.get(this.props.translation, sharedLabelsPath.continents + "." + elem.value)} (${elem.count})`
                }
            });
            let continentsOptions = [
                { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
                ...requestsPerContinentOptions
            ];

            let requestsPerCountryOptions = _.chain(this.props.requestsPerCountry)
                .filter((elem) => _.isNil(this.state.continentFilter) || _.includes(this.props.locationData[this.state.continentFilter], elem.value))
                .map((elem) => {
                    return {
                        value: elem.value,
                        label: `${_.get(this.props.translation, sharedLabelsPath.countries + '.' + elem.value)} (${elem.count})`
                    }
                })
                .value();
            requestsPerCountryOptions = _.orderBy(requestsPerCountryOptions, "label", "asc");
            let countriesOptions = [
                { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
                ...requestsPerCountryOptions
            ];

            let requestsPerDomainOptions = _.map(this.props.requestsPerDomain, (elem) => {
                return {
                    value: elem.value,
                    label: `${elem.value} (${elem.count})`
                }
            });
            requestsPerDomainOptions = _.orderBy(requestsPerDomainOptions, "label", "asc");
            let domainOptions = [
                { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
                ...requestsPerDomainOptions
            ];

            return [
                <div className="filter-container" key='continent-filter'>
                    <h6>{_.get(this.props.translation, sharedLabelsPath.continent_filter_label)}</h6>
                    <Select
                        className="filter-select"
                        selectedOption={_.find(continentsOptions, option => option.value === this.state.continentFilter)}
                        options={continentsOptions}
                        onSelect={this.handleChangeContinentFilter}
                    />
                </div>,
                <div className="filter-container" key='country-filter'>
                    <h6>{_.get(this.props.translation, sharedLabelsPath.country_label)}</h6>
                    <Select
                        className="filter-select"
                        selectedOption={_.find(countriesOptions, option => option.value === this.props.countryFilter)}
                        options={countriesOptions}
                        onSelect={this.handleChangeCountryFilter}
                    />
                </div>,
                <div className="filter-container" key='domain-filter'>
                    <h6>{_.get(this.props.translation, sharedLabelsPath.domain_label)}</h6>
                    <Select
                        className="filter-select"
                        selectedOption={_.find(domainOptions, option => option.value === this.props.domainFilter)}
                        options={domainOptions}
                        onSelect={this.handleChangeDomainFilter}
                    />
                </div>
            ];
        }
    }

    renderContent() {
        if (this.props.loading) {
            return (
                <div className="pending-accreditation-requests-list-status-message-container">
                    <h6 className="page-label">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || _.isEmpty(this.props.data)) {
            return (
                <div className="pending-accreditation-requests-list-status-message-container">
                    <h6 className="page-label">{_.get(this.props.translation, 'accreditation_requests.pending_accreditation_requests_no_data_label')}</h6>
                </div>
            );
        }
        return (
            <Table className='pending-accreditation-requests-list'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'accreditation_list.applicant_name_label')}</th>
                    <th>{_.get(this.props.translation, 'accreditation_requests.applicant_email_label')}</th>
                    <th>{_.get(this.props.translation, 'accreditation_requests.created_at_label')}</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderAccreditationRequestsData()}
                </tbody>
            </Table>
        );
    }

    renderAccreditationRequestsData() {
        if (!this.props.loading) {
            return _.map(this.props.data, (request, index) => (
                <tr key={index} className="pending-accreditation-requests-list-row" onClick={this.handleClick(request.id)}>
                    <td className='accreditation-applicant-name-td'
                        data-th={_.get(this.props.translation, 'accreditation_list.applicant_name_label') + ":"}>
                        {request.verifiedIdentity.firstName + ' ' + request.verifiedIdentity.lastName}
                    </td>
                    <td className='accreditation-applicant-email-td'
                        data-th={_.get(this.props.translation, 'accreditation_requests.applicant_email_label') + ":"}>
                        {request.applicantEmail}
                    </td>
                    <td className='accreditation-applicant-created-at-td'
                        data-th={_.get(this.props.translation, 'accreditation_requests.created_at_label') + ":"}>
                        {moment(request.createdAt).format('LL')}
                    </td>
                    <td className='create-icon-td'>
                        <IconContainer icon='create'
                                       key={'create' + index}
                                       title={_.get(this.props.translation, 'accreditation_list.edit_label')}
                                       className="create-accreditation-icon"/>
                    </td>
                </tr>
            ));
        }
    }

    handleClick = (id) => () => {
        this.setState({redirect: true});
        this.props.onStartValidation(id);
    };

    handleChangeContinentFilter = (selectedOption) => {
        this.setState({continentFilter: selectedOption.value});
    }

    handleChangeCountryFilter = (selectedOption) => {
        this.props.onUpdateCountryFilter(selectedOption.value);
    }

    handleChangeDomainFilter = (selectedOption) => {
        this.props.onUpdateDomainFilter(selectedOption.value);
    }

    componentDidMount() {
        this.props.onLoadAccreditationRequests(this.props.group);
        if (this.props.isOrgBava) {
            this.props.onLoadARsPerCountry(this.props.group);
            this.props.onLoadARsPerDomain(this.props.group);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.group !== prevProps.group) {
            this.props.onLoadAccreditationRequests(this.props.group);
            if (this.props.isOrgBava) {
                this.props.onClearCountryFilter();
                this.props.onClearDomainFilter();
                this.props.onLoadARsPerCountry(this.props.group);
                this.props.onLoadARsPerDomain(this.props.group);
            }
        }
    }

    componentWillUnmount() {
        this.props.onClearCountryFilter();
        this.props.onClearDomainFilter();
    }
}

PendingAccreditationRequestsList.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    group: PropTypes.string,
    isOrgBava: PropTypes.bool,
    requestsPerCountry: PropTypes.array,
    requestsPerContinent: PropTypes.array,
    countryFilter: PropTypes.string,
    locationData: PropTypes.object,
    onStartValidation: PropTypes.func,
    onLoadAccreditationRequests: PropTypes.func,
    onLoadARsPerCountry: PropTypes.func,
    onUpdateCountryFilter: PropTypes.func,
    onClearCountryFilter: PropTypes.func,
    onLoadARsPerDomain: PropTypes.func,
    onUpdateDomainFilter: PropTypes.func,
    onClearDomainFilter: PropTypes.func,
};

export default PendingAccreditationRequestsList;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/pendingAccreditationRequestsList/PendingAccreditationRequestsList.js